import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from "@mui/lab";
import React from "react";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Typography } from "@mui/material";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import GradingIcon from "@mui/icons-material/Grading";
import DescriptionIcon from "@mui/icons-material/Description";
import PublicIcon from "@mui/icons-material/Public";

export const Libro = ({ estado }) => {
  return (
    <Timeline
      position="right"
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 1,
        },
      }}
    >
      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 0 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 0 ? "darkGreen" : "darkOrange" }}
          >
            <AttachMoneyIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 0 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Procesando Pago</strong> <br />-{" "}
            {estado > 0 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 1 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 1 ? "darkGreen" : "darkOrange" }}
          >
            <DescriptionIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 1 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Elaboración</strong> <br />-{" "}
            {estado > 1 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 2 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 2 ? "darkGreen" : "darkOrange" }}
          >
            <NoteAltIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 2 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Edición</strong> <br />-{" "}
            {estado > 2 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 3 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 3 ? "darkGreen" : "darkOrange" }}
          >
            <GradingIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 3 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Revisión</strong>
            <br />- {estado > 3 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 4 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 4 ? "darkGreen" : "darkOrange" }}
          >
           <AttachMoneyIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 4 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Carta de Aceptación</strong> <br />-{" "}
            {estado > 4 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector
            sx={{ bgcolor: estado > 5 ? "darkGreen" : "darkOrange" }}
          />
          <TimelineDot
            sx={{ backgroundColor: estado > 5 ? "darkGreen" : "darkOrange" }}
          >
            <PublicIcon />
          </TimelineDot>
          <TimelineConnector
            sx={{ bgcolor: estado > 5 ? "darkGreen" : "darkOrange" }}
          />
        </TimelineSeparator>
        <TimelineContent sx={{ my: "auto" }}>
          <Typography component="span" fontSize={"14px"}>
            <strong>Publicación</strong> <br />-{" "}
            {estado > 5 ? "Completado" : "Pendiente"}
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};
